import { useMemo } from 'react';
import { ApolloError } from '@apollo/client';

import { useErpStudentHomeworkQuery } from 'core/graphql';

import { IStudentHomeworkRow } from './homeworkModel';

interface IStudentHomeworkHook {
  rows: IStudentHomeworkRow[];
  loading: boolean;
  error?: ApolloError;
  refetch: () => void;
}

/**
 * Spec 0012 — the «Домашние задания» tab of the student card: the student's
 * homework history across all their groups (`studentHomeworkForErp`), one row
 * per assignment the student was eligible for.
 */
export const useStudentHomework = (
  studentId?: string,
): IStudentHomeworkHook => {
  const { data, loading, error, refetch } = useErpStudentHomeworkQuery({
    variables: { studentId: studentId || '' },
    skip: !studentId,
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
  });

  const rows = useMemo(() => data?.studentHomeworkForErp ?? [], [
    data?.studentHomeworkForErp,
  ]);

  return {
    rows,
    loading,
    error,
    refetch: () => {
      refetch();
    },
  };
};
